module.exports = __webpack_public_path__ + "static/media/electronic-eng.71c18d26.jpg";